import { api } from "./api";
import { BaeringUser } from "../types/user";
import { ApiResponse } from "../types/api";

export const userService = {
  // 전체 유저 조회
  getAllUsers: async (): Promise<BaeringUser[]> => {
    const response = await api.get<ApiResponse<BaeringUser[]>>(
      "/api/admin/user/baering",
      { withCredentials: true },
    );
    return response.data.data;
  },

  // 유저 상세 조회
  getUserById: async (id: number): Promise<BaeringUser> => {
    const response = await api.get<ApiResponse<BaeringUser>>(
      `/api/admin/user/${id}`,
    );
    return response.data.data;
  },

  // 유저 정보 수정
  updateUser: async (id: number, user: Partial<BaeringUser>): Promise<void> => {
    await api.put(`/api/admin/user/${id}`, user);
  },

  // 블랙리스트 상태 변경 (빠른 토글 전용)
  updateBlacklist: async (
    id: number,
    isBlacklist: boolean,
    isBlacklistPhone: boolean
  ): Promise<void> => {
    await api.patch(`/api/admin/user/${id}/blacklist`, {
      isBlacklist,
      isBlacklistPhone,
    });
  },

  // 유저 삭제
  deleteUser: async (id: number): Promise<void> => {
    await api.delete(`/api/admin/user/${id}`);
  },
};
